export default __webpack_public_path__ + "static/media/rubik-v12-latin-600.71381241.woff";